import { Renderer2, ElementRef, QueryList } from '@angular/core';
import { categoryEnum } from '@app/forms/subscription/definition/interface';
type CompletedQuestions = { [key: string]: boolean };
type StepIconsCompleted = { [key: string]: boolean };
export const updateSvgPath = (
  step: string,
  i: number,
  selectStep: QueryList<ElementRef>,
  completedQuestions: CompletedQuestions,
  category,
  renderer?: Renderer2,
  stepIconCompleted: StepIconsCompleted = {},
) => {
  const elementNumberSvg: HTMLElement = selectStep?.toArray()[i]?.nativeElement;
  const numbers = elementNumberSvg?.querySelectorAll('.green-svg-number');
  const el = elementNumberSvg?.querySelector('.step');

  if (step == category && !completedQuestions[step]) {
    setHourglass(stepIconCompleted, step, elementNumberSvg, renderer);
  }
  if (numbers?.length !== 4 && numbers?.length && step == category) {
    setHourglass(stepIconCompleted, step, elementNumberSvg, renderer);
  } else if (numbers?.length === 4 && completedQuestions[step]) {
    updateCompletedStep(el, renderer);
    stepIconCompleted[step] = false;
  } else if (completedQuestions[step]) {
    stepIconCompleted[step] = false;
    updateCompletedStep(el, renderer);
  }
};
function setHourglass(
  stepIconCompleted: StepIconsCompleted,
  step: string,
  elementNumberSvg: any,
  renderer: Renderer2,
) {
  stepIconCompleted[step] = true;
  const el = elementNumberSvg?.querySelector('.step');
  if (el) {
    renderer.addClass(el, 'border');
    renderer.removeClass(el?.querySelector('.step__logo'), 'green-svg');
    renderer.setAttribute(el?.querySelector('svg > path'), 'stroke', '#01A341');
  }
}
function updateCompletedStep(el: Element, renderer: Renderer2): void {
  if (el) {
    renderer.removeClass(el, 'border');
    renderer.addClass(el?.querySelector('.step__logo'), 'green-svg');
    renderer.setAttribute(el?.querySelector('svg > path'), 'stroke', 'white');
  }
}

export const steps = Object.values(categoryEnum).filter(
  val => typeof val === 'string',
) as string[];

export const completedQuestions = steps.reduce(
  (obj, category) => ({ ...obj, [category]: false }),
  {},
);
